import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { headerTitles } from "../../actions/masterdata/masterdata";
import NodataComponent from "../Common/NodataComponent";
import banner from "./assets/d_banner.png";
import no_loan from "./assets/no_loan.png";
import rd from "./assets/rd.png";
import std from "./assets/std.png";
import rfd from "./assets/rfd.png";
import tick from "./assets/circle_tick.png";
import "./Loan.css";
import FDForm from "../Deposits/FD";

const loanData = [
  {
    title: "Regular Fixed Deposit",
    description: "Park surplus funds as a lumpsum and enjoy attractive returns",
    benefits: [
      "Choose the interest pay-out",
      "Amount less than INR 3Cr",
      "Auto-renew facitilty",
    ],
    buttonText: "Apply now",
    image: rfd,
  },
  {
    title: "Recurring Deposit",
    description:
      "Deposit that allows to make regular deposits and earn attractive returns",
    benefits: [
      "Period of 6months to 10 years*",
      "Attractive interest rates",
      "Auto-renew facitilty",
    ],
    buttonText: "Apply now",
    image: rd,
  },
  {
    title: "Short Term FD",
    description:
      "Short term FDs give a tenure that ranges from 7days to 12months",
    benefits: [
      "Period of 7days to 12months",
      "Min deposit amount Rs. 1000",
      "Auto-renew facitilty",
    ],
    image: std,
    buttonText: "Apply now",
  },
];

const Deposits = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("applied");
  const [openForm, setOpenForm] = useState(false);

  useEffect(() => {
    dispatch(
      headerTitles({
        title: t("Deposits"),
        description: "",
      })
    );
  }, []);

  return openForm ? (
    <FDForm setOpenAddNew={setOpenForm} />
  ) : (
    <section className="d-flex flex-col loans-sec">
      <div className="v-center gap4 mt2 tabsSection">
        <span
          className={activeTab === "applied" ? "active" : ""}
          onClick={() => {
            setActiveTab("applied");
          }}
        >
          {t("Apply Deposits")}
        </span>
        <span
          className={activeTab === "active" ? "active" : ""}
          onClick={() => {
            setActiveTab("active");
          }}
        >
          {t("active")}
        </span>
        <span
          className={activeTab === "closed" ? "active" : ""}
          onClick={() => {
            setActiveTab("closed");
          }}
        >
          {t("closed")}
        </span>
      </div>
      <img src={banner} />
      {activeTab === "applied" ? (
        <div className="applyLoanCards-container">
          {loanData.map((loan, index) => (
            <DepositCard
              key={index}
              title={loan.title}
              description={loan.description}
              benefits={loan.benefits}
              buttonText={loan.buttonText}
              image={loan.image}
              setOpenForm={setOpenForm}
            />
          ))}
        </div>
      ) : (
        <div className="w-35 mt3 card-container flex-col">
          <NodataComponent
            title={
              activeTab === "closed"
                ? `You don't have any closed loans`
                : activeTab === "active"
                ? `You don't have any active loans`
                : `You haven't applied for any loans`
            }
            primaryText={"Apply Now"}
            img={no_loan}
            msg={" "}
            hasWriteAccess={true}
            noSecBtn
            onPrimaryClick={() => {
              window.open(`https://loans.syntizen.app/`);
            }}
          />
        </div>
      )}
    </section>
  );
};

const DepositCard = ({
  title,
  description,
  benefits,
  buttonText,
  image,
  setOpenForm,
}) => {
  return (
    <div className="loan-card card">
      <img
        src={image}
        style={{
          height: "6rem",
        }}
      />
      <div className="head-sec">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <ul className="benefits">
        {benefits.map((benefit, index) => (
          <li key={index}>
            <img src={tick} width={20} />
            {benefit}
          </li>
        ))}
      </ul>
      <div className="button-container mt1">
        <button
          className="apply-btn"
          onClick={() => {
            // window.open(`https://loans.syntizen.app/`);
            setOpenForm(true);
          }}
        >
          {buttonText}
        </button>
        <button className="outlineButton">More Details</button>
      </div>
    </div>
  );
};

export default Deposits;
